<i18n
  src="@/locales/views/agro_exporter/providers/producers/show_producer.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/producer.yml" lang="yaml"></i18n>

<template>
  <div class="mt-8">
    <div class="panel">
      <div class="panel-header">
        <h3 class="panel-header-title">
          {{ $t("labels.title") }}
        </h3>
      </div>

      <div class="panel-body">
        <div class="space-y-8 divide-y divide-gray-200">
          <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-3">
              <dt class="label-data">
                {{ $t("model.producer.organization_producer.producer_code") }}
              </dt>
              <dd class="content-data">
                {{ producer.agro_exporter_producer.producer_code }}
                <span class="space-icon" />
                <yes-no-label
                  :value="producer.agro_exporter_producer.active"
                  yes="Activo"
                  no="Inactivo"
                />
              </dd>
            </div>

            <div class="sm:col-span-3">
              <dt class="label-data">
                {{ $t("model.producer.producer_code") }}
              </dt>
              <dd class="content-data">
                {{ producer.producer_code }}
              </dd>
            </div>

            <div class="sm:col-span-3">
              <dt class="label-data">
                {{ $t("model.producer.lastname") }}
              </dt>
              <dd class="content-data">
                {{ producer.lastname }}
              </dd>
            </div>

            <div class="sm:col-span-3">
              <dt class="label-data">
                {{ $t("model.producer.name") }}
              </dt>
              <dd class="content-data">
                {{ producer.name }}
              </dd>
            </div>

            <div class="sm:col-span-3">
              <dt class="label-data">
                {{ $t("model.producer.gender_id") }}
              </dt>
              <dd class="content-data">
                {{ genderName(producer.gender_id) }}
              </dd>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GenderMixin from "@/components/views/mixins/organization/genders.js";

export default {
  name: "AEProvidersProducersProducerInfo",
  mixins: [GenderMixin],
  data() {
    return {
      load_general_data: false,
      proc_button_destroy: false
    };
  },
  props: {
    producer: { required: true }
  },
  computed: {
    producer_crops: function () {
      return (this.producer.producer_crops || [])
        .map(producer_crop => producer_crop.crop.name)
        .join(", ");
    }
  }
};
</script>
